import axios from 'axios'

export const ContentSectionApi = {
    http: axios.create(),
    cancelTokenSource: {},

    async queryXmlIds(xmlIdsQuery) {
        const routeUri = Routing.generate("playground_api_content_section_by_id", xmlIdsQuery);
        let response = await this.http.get(routeUri);
        return response.data.sections;
    },

    async queryByUserNotes(queryParams) {
        const apiName = 'api_content_sections_by_user_notes';
        const routeUri = Routing.generate(apiName, queryParams);
        if (this.cancelTokenSource[apiName]) {
            this.cancelTokenSource[apiName].cancel('Operation canceled due to new request.');
        }

        this.cancelTokenSource[apiName] = axios.CancelToken.source();


        let response = await this.http.get(routeUri, {
            cancelToken: this.cancelTokenSource[apiName].token
        });
        this.cancelTokenSource[apiName] = null;

        return response.data;
    },

    async getSectionContentBySectionId(contentId) {
        const routeUri = Routing.generate("api_content_section_by_content_id", {contentId: contentId});
        let response = await this.http.get(routeUri);
        return response;
    },

    async getSectionsContentByXmlIds(xmlIds) {
        const routeUri = Routing.generate("api_content_section_by_id", { xmlIds });
        let response = await this.http.get(routeUri);
        return response;
    }
};
